/** @format */

import React, { ReactNode } from 'react';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import withStyles from '@material-ui/core/styles/withStyles';
import adescomStyle from '../../assets/jss/adescom/adescomStyle';
import GridContainer from '../../components/Grid/GridContainer';
import GridItem from '../../components/Grid/GridItem';
import Card from '../../components/Card/Card';
import CardBody from '../../components/Card/CardBody';
import CardHeader from '../../components/Heading/CardHeaderExt';
import { FileCogOutline } from 'mdi-material-ui';
import { PlatformResellerLoader } from '../../modules/platformreseller/PlatformResellerLoader';
import { ItemLoaders } from '../../core/loaders/ItemLoaders';
import { Auth } from '../../modules/auth/Auth';
import PlatformResellerInterface from '../../interfaces/platform/PlatformResellerInterface';
import { FormGeneralHelper } from '../../helpers/FormGeneral';
import InputFormRest from '../../components/Form/InputFormRest';
import { platformResellerConstants } from '../../modules/platformreseller/actions';
import CustomButtom from '../../components/CustomButtons/ButtonExt';
import I18n from '../../components/Translate/I18n';

interface FileInterfaceProps {
    classes: any;
    dispatch: any;

    showMainLoader(value: boolean): void;
}

interface FileInterfaceState {
    platformReseller: null | PlatformResellerInterface;
    entityStatus: {
        cdrs: null;
        loc: null;
        dwh: null;
        sgv: null;
        nrtrde: null;
    };
    entity: {
        cdrs: string | null;
        loc: string | null;
        dwh: string | null;
        sgv: string | null;
        nrtrde: string | null;
    };
}

class FileInterface extends React.Component<FileInterfaceProps, FileInterfaceState> {
    private itemLoader: ItemLoaders;
    private platformResellersLoader: PlatformResellerLoader;

    constructor(props: FileInterfaceProps, context: FileInterfaceState) {
        super(props, context);

        this.state = {
            platformReseller: null,
            entity: {
                cdrs: null,
                loc: null,
                dwh: null,
                sgv: null,
                nrtrde: null,
            },
            entityStatus: {
                cdrs: null,
                loc: null,
                dwh: null,
                sgv: null,
                nrtrde: null,
            },
        };

        this.itemLoader = new ItemLoaders(this.props.dispatch);
        this.platformResellersLoader = new PlatformResellerLoader(this.itemLoader);
    }

    componentDidMount(): void {
        this.loadPlatformReseller();
    }

    loadPlatformReseller = (): void => {
        this.platformResellersLoader.loadPlatformResellerById(Auth.getUserPlatformResellerId(), (data) => {
            const entity = this.state.entity;
            if (data.fileInterfacePaths !== null) {
                const paths = JSON.parse(data.fileInterfacePaths);
                entity.cdrs = paths.cdrs;
                entity.loc = paths.loc;
                entity.dwh = paths.dwh;
                entity.sgv = paths.sgv;
                entity.nrtrde = paths.nrtrde;
            }
            this.setState({ platformReseller: data, entity });
        });
    };

    updateResellerPaths = (e: any): void => {
        e.preventDefault();

        const paths = JSON.stringify(this.state.entity);
        if (!this.state.platformReseller) {
            return;
        }
        let platformReseller: { id: number; fileInterfacePaths: null | string } = {
            id: this.state.platformReseller.id,
            fileInterfacePaths: paths,
        };

        this.itemLoader.putWithCallback(
            FormGeneralHelper.getByUri(this.state.platformReseller['@id']),
            platformResellerConstants.PLATFORM_RESELLER_EDIT,
            { ...platformReseller },
            (data: any) => {
                console.error({ data });
            },
            {
                propagateDataToCallback: true,
                dispatchAfterCallback: true,
                dispatchErrorAfterCallback: true,
            }
        );
    };

    change = (e: any, stateName: string, type: string, require: any, maxValue: any, minValue: any): void => {
        FormGeneralHelper.validateForms(this, e, stateName, type, require, maxValue, minValue);
    };

    render(): ReactNode {
        const { classes } = this.props;
        const { entity, entityStatus } = this.state;

        return (
            <form onSubmit={this.updateResellerPaths} key="reseller_paths_update">
                <Card>
                    <CardHeader icon={<FileCogOutline />} trans="general:menu.file_interface" />
                    <CardBody>
                        <GridContainer>
                            <GridItem xs={12} sm={12} md={12}>
                                <InputFormRest
                                    classes={classes}
                                    callback={this.change}
                                    stateName="cdrs"
                                    stateObjectState={entityStatus.cdrs}
                                    typeCallback={FormGeneralHelper.TYPE_TEXT}
                                    typeField={FormGeneralHelper.TYPE_TEXT}
                                    displayFieldName="platform_reseller:file_interface.cdrs"
                                    vMax={256}
                                    vMin={-1}
                                    required={false}
                                    value={entity.cdrs}
                                />
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12}>
                                <InputFormRest
                                    classes={classes}
                                    callback={this.change}
                                    stateName="loc"
                                    stateObjectState={entityStatus.loc}
                                    typeCallback={FormGeneralHelper.TYPE_TEXT}
                                    typeField={FormGeneralHelper.TYPE_TEXT}
                                    displayFieldName="platform_reseller:file_interface.loc"
                                    vMax={256}
                                    vMin={-1}
                                    required={false}
                                    value={entity.loc}
                                />
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12}>
                                <InputFormRest
                                    classes={classes}
                                    callback={this.change}
                                    stateName="dwh"
                                    stateObjectState={entityStatus.dwh}
                                    typeCallback={FormGeneralHelper.TYPE_TEXT}
                                    typeField={FormGeneralHelper.TYPE_TEXT}
                                    displayFieldName="platform_reseller:file_interface.dwh"
                                    vMax={256}
                                    vMin={-1}
                                    required={false}
                                    value={entity.dwh}
                                />
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12}>
                                <InputFormRest
                                    classes={classes}
                                    callback={this.change}
                                    stateName="sgv"
                                    stateObjectState={entityStatus.sgv}
                                    typeCallback={FormGeneralHelper.TYPE_TEXT}
                                    typeField={FormGeneralHelper.TYPE_TEXT}
                                    displayFieldName="platform_reseller:file_interface.sgv"
                                    vMax={256}
                                    vMin={-1}
                                    required={false}
                                    value={entity.sgv}
                                />
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12}>
                                <InputFormRest
                                    classes={classes}
                                    callback={this.change}
                                    stateName="nrtrde"
                                    stateObjectState={entityStatus.nrtrde}
                                    typeCallback={FormGeneralHelper.TYPE_TEXT}
                                    typeField={FormGeneralHelper.TYPE_TEXT}
                                    displayFieldName="platform_reseller:file_interface.nrtrde"
                                    vMax={256}
                                    vMin={-1}
                                    required={false}
                                    value={entity.nrtrde}
                                />
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12}>
                                <CustomButtom type="submit">
                                    <I18n trans="general:common.save" />
                                </CustomButtom>
                            </GridItem>
                        </GridContainer>
                    </CardBody>
                </Card>
            </form>
        );
    }
}

const stateToProps = (state: any): object => {
    return {};
};

export default compose<any, any>(connect(stateToProps), withStyles(adescomStyle))(FileInterface);
